import {Base} from "@/api/Base"

export class CommissionRateDelete extends Base {
    path = "commissionRate/delete"
}